import {hitGoogleTagManager} from "../google_tag_manager/gtm_init";

export interface IOfferViewEvent {
    offer_id: string;
    offer_slug?: string;
    make?: string;
    model?: string;
    year?: string;
    price?: string | number;
    city?: string;
    page_type?: string;
}

/**
 * Sends offer page view hit to GTM (for GA4 via GTM tag).
 */
export const hitOfferViewEvent = (props: IOfferViewEvent) => {
    const {offer_id, offer_slug, make, model, year, price, city, page_type} = props;

    if (!offer_id) {
        return;
    }

    hitGoogleTagManager({
        event: "offer_view",
        offer_id: String(offer_id),
        ...(offer_slug ? {offer_slug} : {}),
        ...(make ? {make} : {}),
        ...(model ? {model} : {}),
        ...(year ? {year} : {}),
        ...(price != null && price !== "" ? {price} : {}),
        ...(city ? {city} : {}),
        ...(page_type ? {page_type} : {})
    });
};
